import * as React from "react";
function HalfCircleProgressIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 8a6 6 0 00-6 6 2 2 0 11-4 0C0 8.477 4.477 4 10 4s10 4.477 10 10a2 2 0 11-4 0 6 6 0 00-6-6z",
    clipRule: "evenodd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.4 5.774a2 2 0 01-1.276 2.524A6.003 6.003 0 004 14a2 2 0 11-4 0c0-4.435 2.885-8.19 6.875-9.502A2 2 0 019.4 5.774z",
    clipRule: "evenodd"
  }));
}
const ForwardRef = React.forwardRef(HalfCircleProgressIcon);
export default ForwardRef;